import app from '../../scripts/app';
import template from './expander.jade';

app.directive('cianAfExpander', () => ({
  template,
  transclude: true,
  scope: {},
  bindToController: {
    collapsedHeight: '<',
    isExpanded: '=?',
  },
  controller($element, $timeout) {
    'ngInject';

    if (angular.isUndefined(this.isExpanded)) {
      this.isExpanded = false;
    }

    const content = $element[0].querySelector('.js-ref-content');
    const $content = angular.element(content);
    $content.on('transitionend', () => {
      this.transitionComplete = true;
    });

    const updateHeight = () => {
      this.expandedHeight = $content[0].scrollHeight;
    };
    $timeout(updateHeight);

    this.contentStyle = () => ({
      maxHeight: (this.isExpanded ? this.expandedHeight : this.collapsedHeight) + 'px',
      // Чтобы в разворачиваемом контенте нормально отображались дропдауны и выпадушки
      overflow: this.isExpanded && this.transitionComplete ? 'visible' : 'hidden',
    });

    this.toggle = () => {
      this.isExpanded = !this.isExpanded;
      this.transitionComplete = false;
      if (this.isExpanded) {
        updateHeight();
      }
    };
  },
  controllerAs: '$ctrl',
}));
